import { Injectable } from "@angular/core";
import { BehaviorSubject, of } from "rxjs";
import { ConfigService } from "../core/services/config.service";
import { ApiService } from "../core/services/api.service";

export type Register = {
  register: string
  key: string
  items: Array<{fieldName: string, value: string }>
}

@Injectable({
  providedIn: "root",
})
export class TooltipReaderService {
  private tooltipRegisters = { };
  private cache = {};

  constructor(
    readonly configSerivce: ConfigService,
    readonly apiService: ApiService
  ) {}

  loadTooltip(register: string) {
    const subject: BehaviorSubject<any> = this.tooltipRegisters[register];
    if (subject) {
      return subject;
    }

    const registerSubject = new BehaviorSubject<any>(undefined);
    this.tooltipRegisters = { ...this.tooltipRegisters, [`${register}`]: registerSubject };

    this.apiService
      .find(`${this.configSerivce.RegisterTooltipUrl}${register}`)
      .subscribe((tooltip: Register) => {
        const subject = this.tooltipRegisters[register];
        subject.next(tooltip)
      });

      return registerSubject;
  }

  getTooltipForRegisiter({
    registerName,
    fieldName,
  }: {
    registerName: string;
    fieldName: string;
  }) {
    const cacheKey = `${registerName}:${fieldName}`;
    if (this.cache[`${cacheKey}`]) {
      return this.cache[`${cacheKey}`];
    }
    const regsterSubject:  BehaviorSubject<any> = this.tooltipRegisters[registerName];
    const register: Register = regsterSubject.getValue();

    const value = register?.items.find((item) => item.fieldName === fieldName)?.value;
    this.cache[`${cacheKey}`] = value;
    return value;
  }
}
